import styled from 'styled-components';
import React, { useState } from 'react';
import media from 'client/styles/media';
import { ButtonInline } from 'client/components/elements';

import PaddingContainer from './PaddingContainer';

const HowDiffersSection = styled(PaddingContainer)`
  position: relative;
  width: 100%;
  h2 {
    ${({ theme }) => theme.typography.h1};
    font-size: 36px;
    margin: 0;
  }

  .differs-from {
    position: relative;
    background: url(https://static.introwise.com/images/elements/main/orange_frame.svg) no-repeat;
    background-size: 100% 100%;
    padding: 50px 50px 70px 30px;
    margin: 0 -30px;
    min-height: 250px;
    display: flex;
    align-items: center;
    svg {
      position: absolute;
      right: 20px;
      bottom: 20px;
    }
  }
  .differs-how {
    background: url(https://static.introwise.com/images/elements/main/orange_block.svg) no-repeat;
    background-size: 100% 100%;
    padding: 20px 30px 40px;
    margin: -10px -30px 0;

    table {
      width: 100%;
      max-width: 460px;
      text-align: center;
    }

    thead {
      ${({ theme }) => theme.typography.h4};
      th {
        vertical-align: bottom;
        text-align: center;
        padding-bottom: 10px;
      }
      span {
        display: none;
      }
      img {
        display: inline-block;
        width: 29px;
        height: 40px;
      }
    }

    tbody {
      td {
        width: 12%;
        vertical-align: top;
        padding: 12px 0;
        font-size: 36px;
        line-height: 26px;
        &:first-child {
          width: 76%;
          text-align: left;
          padding-right: 10px;
          ${({ theme }) => theme.typography.regular};
        }
      }
    }
  }
  ${media.sm} {
    margin-top: 80px;
    margin-bottom: 80px;
    .differs-from {
      margin: 0;
    }
    .differs-how {
      margin: -10px 0 0;
    }
  }

  ${media.md} {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 16px;

    h2 {
      font-size: 36px;
      line-height: 140%;
    }
    .differs-from {
      display: block;
      grid-column: 1 / span 5;
      margin-right: -20px;
      min-height: 392px;
      padding: 75px 50px 100px;

      svg {
        position: absolute;
        left: 50px;
        bottom: 50px;
      }
    }
    .differs-how {
      grid-column: 6 / span 7;
      padding: 40px 40px;
      margin: 0;
      table {
        max-width: 400px;
      }
      thead {
        img {
          display: none;
        }
        span {
          display: block;
        }
      }

      tbody {
        td {
          width: 25%;
          &:first-child {
            width: 50%;
          }
        }
      }
    }
  }

  ${media.lg} {
    .differs-from {
      grid-column: 2 / span 4;
    }
    .differs-how {
      grid-column: 6 / span 6;
    }
  }
`;

const HowDiffersFacebook = () => (
  <table>
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th>Fb</th>
        <th>
          <span>Introwise</span>
          <img src="https://static.introwise.com/images/introwise-logo.svg" alt="Introwise" />
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Updates on what’s going on as a news feed</td>
        <td>+</td>
        <td>+</td>
      </tr>
      <tr>
        <td>No privacy concerns</td>
        <td>–</td>
        <td>+</td>
      </tr>
      <tr>
        <td>Public group chats</td>
        <td>–</td>
        <td>+</td>
      </tr>
      <tr>
        <td>No noise and relevant topics on the top</td>
        <td>–</td>
        <td>+</td>
      </tr>
    </tbody>
  </table>
);

const HowDiffersMeetup = () => (
  <table>
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th>Meetup</th>
        <th>
          <span>Introwise</span>
          <img src="https://static.introwise.com/images/introwise-logo.svg" alt="Introwise" />
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Organize small events</td>
        <td>+</td>
        <td>+</td>
      </tr>
      <tr>
        <td>Community page</td>
        <td>+</td>
        <td>+</td>
      </tr>
      <tr>
        <td>Interests based chats</td>
        <td>–</td>
        <td>+</td>
      </tr>
      <tr>
        <td>Big events features: agenda, 1-1 meetings</td>
        <td>–</td>
        <td>+</td>
      </tr>
    </tbody>
  </table>
);

const HowDiffersMessengers = () => (
  <table>
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th>Messengers</th>
        <th>
          <span>Introwise</span>
          <img src="https://static.introwise.com/images/introwise-logo.svg" alt="Introwise" />
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Fast and engaging communication</td>
        <td>+</td>
        <td>+</td>
      </tr>
      <tr>
        <td>Discover new chats based on interests</td>
        <td>–</td>
        <td>+</td>
      </tr>
      <tr>
        <td>See event details and agenda</td>
        <td>–</td>
        <td>+</td>
      </tr>
      <tr>
        <td>One place for events and communities</td>
        <td>–</td>
        <td>+</td>
      </tr>
    </tbody>
  </table>
);
const HowDiffersEventApps = () => (
  <table>
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th>Event Apps</th>
        <th>
          <span>Introwise</span>
          <img src="https://static.introwise.com/images/introwise-logo.svg" alt="Introwise" />
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Create page with event details and agenda, checkin participants</td>
        <td>+</td>
        <td>+</td>
      </tr>
      <tr>
        <td>Advanced content management, email marketing</td>
        <td>+</td>
        <td>-</td>
      </tr>
      <tr>
        <td>Engaging and relevant group chats</td>
        <td>–</td>
        <td>+</td>
      </tr>
      <tr>
        <td>Keeping people in the community after the event</td>
        <td>–</td>
        <td>+</td>
      </tr>
    </tbody>
  </table>
);

const HowDiffers = () => {
  const [comparisonIdx, setComparisonIdx] = useState(0);
  const comparisons = ['facebook', 'meetup', 'messengers', 'event apps'];
  const comparisonsComponents = [HowDiffersFacebook, HowDiffersMeetup, HowDiffersMessengers, HowDiffersEventApps];
  const HowDiffersComparison = comparisonsComponents[comparisonIdx];
  return (
    <HowDiffersSection>
      <div className="differs-from">
        <h2>
          How is Introwise different from{' '}
          <ButtonInline
            style={{ color: '#e54500' }}
            onClick={() => setComparisonIdx(prev => (prev + 1) % comparisons.length)}
          >
            {comparisons[comparisonIdx]}
          </ButtonInline>
        </h2>
        <svg width="54" height="54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            opacity=".6"
            d="M23 51.6h-.8c.3 0 0 0 0 0l-.2-.1h.4l1.1-.1 1-.8v-.2.2l.1-.3 1.5-2-.2.5c.2-.2.2-.2.1 0 .2-.3.6-.7.4-.7V48c.3-.3.2 0 .3-.1l.3-.6.3-.7.4-.6.2-.4c0 .1 0 .3-.2.5l-.5.7c.2-.2 0 .2 0 .4l.5-1h.1l.2-.4v.1l.2-.6v.1l.2-.4c.1-.3 0 .2.1 0 .1-.4.3-.6.5-.8-.2 0 .2-.8.2-.8l.1-.4v.2l-.2.5c.2 0 .5-1.1.9-1.4l.4-.7h-.2l.4-.3.2-.5v.2l.1-.3.3-.5V40l.1-.2s-.2.1-.3.4l.5-.9.5-.8v.3l.2-.6.1-.2.2-.2.1-.2.4-.7-.3.4c0-.3.1-.5.3-.6-.2.4.3-.4 0 .2.3-.4 0-.3.3-.7l.2-.3-.1.5v-.2l-.7 1.5.6-1c.6-1.2 1.6-2.7 2-3.8v-.3c.3-.2.5-.6.8-1l-.2.2.1-.4s0 .2.1 0v-.2l.4-.5-.1.3s.2-.4.1-.1l.2-.4c.1-.1 0 .2 0 .2l.7-1.5s.1 0 0 0l.8-1.3-.3.4 1.3-1.9 1.4-1.7.1-.4.3-.2c.5-.7 1-1.3 1.3-2l.2-.4.2-.5.2-.5.2-.6c.1-.5.1-.2.3-.4.3-1 .2-1.3.4-2.3 0 .1 0 .4.2 0v-.5V16.5c0-.2 0-.5-.4-.8-.2-.3-.5-.4-.8-.4H42l-1.2.5c-.7.2 0-.2 0-.1.5-.1.3-.2.4-.2-.3 0-.6.2-.8.1l-.4.1-.5.1h.2c-.4 0-1.2.2-1.2 0l-6.2.8h.1l-.8.2.2-.1c-.7 0-1.3.2-1.9.3.1 0-.5 0 0 0-.3 0-.7-.3-.9-.2l.4.3h-1.1l.6-.1c0-.1-.9 0-.5-.1H28l-.4.1h.3c-.3 0-.4.2-1 .2l-.5.2H26h.2-.8c.2-.2.4 0 .4-.2h-.4c0 .1-.2.2.1.2l-1.4.3c-.5 0 .4-.1.2-.2-1 0-1.1.4-1.7.4-.7 0-.6.1-1.3.2h-.7l.3-.1h-.4s-1 0-1.4.2h.1l-1.3.2c-.6 0-.5 0-1 .2-.2 0-.2-.1 0-.2h.6l2.1-.4c.4-.1-.5.1-.8 0l.7-.1c-.4 0-.3.2-.9.1h-1c-.3 0-.3.2-1 .2h.3l-1 .1c.2 0-.3.1.2 0l-1.2.2H16l.1-.1c.4 0 .5.1.2.2H16h.3l-.2.1H14.4l.6-.1h-1-.1-1.2v.1h.5c-.6.1-.7 0-.8 0 0-.2.5 0 .8-.1H12c.3-.2.7 0 .9-.2h-1.2.6l-.4-.1c.8 0-.1-.1.5-.2-.3 0-.4.1-.8 0 .1.1.4.2 0 .2H11.3c.1-.1.2-.1 0-.2l-.5.1h.2c-.3 0-.5.2-.8.3H9.6a9 9 0 0 1-.6.1l-.5.2c-.4 0-.7.2-1 .3.2 0 .2-.1 0-.1h-.1-.2l.4-.2-.3.1-.8.3c-.2 0 .1-.2 0-.2l-.3.2-.4.2s.1 0 0 0l-.2.1-.2.2-.2.4c-.2.2-.2.5-.1.8v.3c.1.7 0-.1 0 0l.2.6.1.5-.1-.6v.7l.2.3.3.6c-.2-.4-.1 0-.3-.3.1.1.4.8.3.4l.2.8.5.7.4 1c.2.4.5.9 1 1.3.3.3.8.7 1.3.9a1.5 1.5 0 0 0 .3 0h-.1.3l-.1.1a131 131 0 0 0-.4.6V29.6l.1.4.1.4.1.4-.1-.2.1.5.2.5.4.9 1.4 2.8-.2-.2c.3.5.6 1.3.9 1.6a3 3 0 0 0 .2.6l.5.7-.2-.1.8.8.1.2.2.2.2.3.3.5.2.3.4.4h-.2v-.1l-.2-.2-.3-.4a2.7 2.7 0 0 0 .2.4l.4.4h-.1-.1l.4.2h.5v-.1l.1.1.2.4.2.4c-.1-.2-.3-.7-.1-.5.2.6.4.8.7 1.2.2.6-.3-.4-.4-.2v.1l.7 1.4.2.5.2.2v.1l.2.2.2.2a331.4 331.4 0 0 1 .3.3l.1.2v-.1L18 45s0 .2.2.3l.2.2v.2l.2.8v1c0 .2 0 0 0 0v-.5-.3a2.2 2.2 0 0 1-.1.4v1c0 .3 0 .6.2.7l.1.4v.2l.4.2c.1 0 0 0 0 0v-.2l.5.2c.3.2.1.1 0 .1l.2.1h-.2c.3.2.4.2.5.1H20.7l.2.1h.5l.2.2V51.5l.6.2h.2a5.6 5.6 0 0 0 .4 0H23.4l.1-.1H23zM10 28.2zm16.7 19.2l-.5 1c-.2 0-.1 0 0-.2l.4-.6.1-.2zm2-3.1V44v.3zm2.2-3.7v-.1zm0-.5l-.2.3a75.2 75.2 0 0 1 .2-.3z"
            fill="#FCD274"
          />
        </svg>
      </div>
      <div className="differs-how">
        <HowDiffersComparison />
      </div>
    </HowDiffersSection>
  );
};

export default HowDiffers;
